import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Typography } from "@mui/material";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import { connect } from "react-redux";
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { set } from 'lodash';

// ----------------------------------------------------------------------

function LoginForm(props) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [verifyCheck, setVerifyCheck] = useState(false);
  const [text, setText] = useState('');
  const [emailText, setEmailText] = useState(null);
  const [loading, setLoading] = useState(null);
  const [dash, setDash] = useState(null);

  useEffect(() => {
    if(props.user.login && props.user.login !==undefined && loading){
      let randomValue;
      if( props.user.dashboard && props.user.dashboard !== undefined){
        randomValue = props.user.dashboard;

      } else{
        randomValue = Math.floor(Math.random() * 3) + 1;
        const payload2 = {
          dashboard: randomValue
        }
        props.addDashboard(payload2);
      }
      // if (randomValue === "1") {
      //   navigate('/dashboard/antibiotics', { replace: true });
      // } else {
      //   navigate('/dashButton', { replace: true });
      // }
      setLoading(false);
      if (!props.user.profileCompleted && props.user.profileCompleted !== undefined){
        
        navigate('/practiceDetails', { state: { param1: emailText } });
      } else {
        navigate('/dashboard/antibiotics', { replace: true });
      }
    }

    
  }, [props.user]);

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required')
  });

  const formik = useFormik({
    initialValues: {
      email: '@healthmail.ie',
      password: '',
      remember: true
    },
    validationSchema: LoginSchema,
    onSubmit: async () => {

      const payload = {
        email: getFieldProps('email').value,
        password: getFieldProps('password').value
      }
      setEmailText(getFieldProps('email').value);
      setLoading(true);
      const response = await props.login(payload);
      if (response == "Login Successful") {
      } else {
        setText(response);
        setVerifyCheck(true);
      }
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleClick = (param) => {
    navigate('/verifyMail', { state: { param1: param } });
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="username"
            type="email"
            label="Email address"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />

          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            {...getFieldProps('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                  </IconButton>
                </InputAdornment>
              )
            }}
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          <FormControlLabel
            control={<Checkbox {...getFieldProps('remember')} checked={values.remember} />}
            label="Remember me"
          />

          <Link variant="subtitle2" onClick={()=>handleClick('forget')}>
            Forgot password?
          </Link>
        </Stack>

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
        >
          Login
        </LoadingButton>
      </Form>
      <Typography variant="body1" sx={{ color: 'red', marginTop: 3 }}>
        {verifyCheck ? text : ""}
        {verifyCheck && text === "Account is not active yet," ?
            <Typography>
            <Link variant="subtitle2" component="button" onClick={()=>handleClick('register')}>
              click here
            </Link>
            &nbsp; to complete the activation
            </Typography>
          : ""}
      </Typography>

    </FormikProvider>
  );
}

const mapState = state => ({
  user: state.user
});

const mapDispatch = ({
  user: { login,addDashboard } }) => ({
    login: (payload) => login(payload),
    addDashboard: (payload) => addDashboard(payload)
  });

export default connect(mapState, mapDispatch)(LoginForm);
